const validators = {
  value:{
    numericality: {
      greaterThan: 0,
      message: "^errors.usage_logs.add_value"
    }
  },
  unit:{
    length: {
      minimum: 1,
      message: "^errors.usage_logs.add_unit"
    }
  }
    
};
  
export default validators;
// description:{
//   length: {
//     minimum: 1,
//     message: "^errors.usage_logs.add_usage_description"
//   }
// }  